import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../../Assets/Images/logo/global-it-master-logo-header.jpg";
import header from "../../../Assets/Styles/header.module.css";
import { subServices } from "../../../Data/services";

const MobileMenu = () => {
  const [open, setOpen] = useState(false);
  const [serviceMenu, setServiceMenu] = useState(false);
  const [DigitalServiceMenu, DigitalSetServiceMenu] = useState(false);
  const [graphicServiceMenu, graphicSetServiceMenu] = useState(false);
  const [programmingServiceMenu, programmingSetServiceMenu] = useState(false);
  const [writing, setWriting] = useState(false);

  return (
    <section className="border-b">
      <div className="flex justify-between items-center p-2 max-sm:px-10 max-sm:py-3">
        <Link to="/">
          <img className="h-[50px] " src={logo} alt="IT Ghar Logo" />
        </Link>
        <button
          onClick={() => setOpen(true)}
          className="bg-white border border-[#0000002e] h-9  w-10"
        >
          {open ? (
            <i className="fa-solid fa-xmark text-lg text-[#000]"></i>
          ) : (
            <i className="fa-solid fa-bars text-lg text-[#000]" id="bar"></i>
          )}
        </button>
      </div>

      {/* Mobile Menu Items */}

      <div className={`${header.popupMobileMenu} ${open && header.menuOpen}  `}>
        <div className={`${header.menuInner}`}>
          <div className={`${header.navigationInnerMenu}`}>
            <div className="mb-5">
              <Link to="/">
                <img src={logo} className="max-w-[180px] max-h-[50px]" alt="" />
              </Link>
            </div>

            <ul>
              <li onClick={() => setOpen(false)}>
                <Link
                  to="/"
                  className={` border-b border-[#00000014] block  leading-[46px] relative text-[#101130] text-[15px] font-bold font-roboto`}
                >
                  Home
                </Link>
              </li>
              <li>
                <span
                  className={`  border-b border-[#00000014] block  leading-[46px] relative text-[#101130] text-[15px] font-bold font-roboto`}
                >
                  <div>
                    <div className="flex justify-between items-center">
                      Services
                      <button
                        onClick={() => setServiceMenu(!serviceMenu)}
                        className="bg-white border border-[#0000002e] h-7  w-8 flex justify-center items-center"
                      >
                        {serviceMenu ? (
                          <i className="fa-solid fa-sort-up text-base text-[#222222ab]"></i>
                        ) : (
                          <i className="fa-solid fa-caret-down text-base text-[#222222ab]"></i>
                        )}
                      </button>
                    </div>
                    {serviceMenu && (
                      <div className="pl-2">
                        <div className="pt-1">
                          <h4 className="flex justify-between items-center">
                            <span className="text-[#101130] block text-[15px] font-bold font-roboto">
                              Digital Marketing
                            </span>
                            <button
                              onClick={() =>
                                DigitalSetServiceMenu(!DigitalServiceMenu)
                              }
                              className="bg-white border border-[#0000002e] h-7  w-8 flex justify-center items-center"
                            >
                              {DigitalServiceMenu ? (
                                <i className="fa-solid fa-sort-up text-base text-[#222222ab]"></i>
                              ) : (
                                <i className="fa-solid fa-caret-down text-base text-[#222222ab]"></i>
                              )}
                            </button>
                          </h4>
                          {DigitalServiceMenu && (
                            <div className="ml-3">
                              {subServices.slice(0, 5).map((service) => (
                                <li
                                  onClick={() => setOpen(false)}
                                  key={service._id}
                                  className="text-sm text-gray-600 my-2.5"
                                >
                                  <Link
                                    className="hover:text-primary text-[#101130] font-bold text-xs"
                                    to={`/categories/${service.slug}`}
                                  >
                                    {service.title}
                                  </Link>
                                </li>
                              ))}
                            </div>
                          )}
                        </div>
                        <div className="pt-1">
                          <h4 className="flex justify-between items-center">
                            <span className="text-[#101130] block text-[15px] font-bold font-roboto">
                              Graphics & Design
                            </span>
                            <button
                              onClick={() =>
                                graphicSetServiceMenu(!graphicServiceMenu)
                              }
                              className="bg-white border border-[#0000002e] h-7  w-8 flex justify-center items-center"
                            >
                              {graphicServiceMenu ? (
                                <i className="fa-solid fa-sort-up text-base text-[#222222ab]"></i>
                              ) : (
                                <i className="fa-solid fa-caret-down text-base text-[#222222ab]"></i>
                              )}
                            </button>
                          </h4>
                          {graphicServiceMenu && (
                            <div className="ml-3">
                              {subServices.slice(5, 10).map((service) => (
                                <li
                                  onClick={() => setOpen(false)}
                                  key={service._id}
                                  className="text-sm text-gray-600 my-2.5"
                                >
                                  <Link
                                    className="hover:text-primary text-[#101130] font-bold text-xs"
                                    to={`/categories/${service.slug}`}
                                  >
                                    {service.title}
                                  </Link>
                                </li>
                              ))}
                            </div>
                          )}
                        </div>
                        <div className="pt-1">
                          <h4 className="flex justify-between items-center">
                            <span className="text-[#101130] block text-[15px] font-bold font-roboto">
                              Programming & Tech
                            </span>
                            <button
                              onClick={() =>
                                programmingSetServiceMenu(
                                  !programmingServiceMenu
                                )
                              }
                              className="bg-white border border-[#0000002e] h-7  w-8 flex justify-center items-center"
                            >
                              {programmingServiceMenu ? (
                                <i className="fa-solid fa-sort-up text-base text-[#222222ab]"></i>
                              ) : (
                                <i className="fa-solid fa-caret-down text-base text-[#222222ab]"></i>
                              )}
                            </button>
                          </h4>
                          {programmingServiceMenu && (
                            <div className="ml-3">
                              {subServices.slice(10, 15).map((service) => (
                                <li
                                  onClick={() => setOpen(false)}
                                  key={service._id}
                                  className="text-sm text-gray-600 my-2.5"
                                >
                                  <Link
                                    className="hover:text-primary text-[#101130] font-bold text-xs"
                                    to={`/categories/${service.slug}`}
                                  >
                                    {service.title}
                                  </Link>
                                </li>
                              ))}
                            </div>
                          )}
                        </div>
                        <div className="pt-1">
                          <h4 className="flex justify-between items-center">
                            <span className="text-[#101130] block text-[15px] font-bold font-roboto">
                              Writing & Translation
                            </span>
                            <button
                              onClick={() => setWriting(!writing)}
                              className="bg-white border border-[#0000002e] h-7  w-8 flex justify-center items-center"
                            >
                              {writing ? (
                                <i className="fa-solid fa-sort-up text-base text-[#222222ab]"></i>
                              ) : (
                                <i className="fa-solid fa-caret-down text-base text-[#222222ab]"></i>
                              )}
                            </button>
                          </h4>
                          {writing && (
                            <div className="ml-3">
                              {subServices.slice(15, 20).map((service) => (
                                <li
                                  onClick={() => setOpen(false)}
                                  key={service._id}
                                  className="text-sm text-gray-600 my-2.5"
                                >
                                  <Link
                                    className="hover:text-primary text-[#101130] font-bold text-xs"
                                    to={`/categories/${service.slug}`}
                                  >
                                    {service.title}
                                  </Link>
                                </li>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </span>
              </li>

              <li>
                <Link
                  to="/course"
                  className={` border-b border-[#00000014] block  leading-[46px] relative text-primary text-[15px] font-bold font-roboto`}
                >
                  Course
                </Link>
              </li>
              <li>
                <Link
                  to="/portfolio"
                  className={` border-b border-[#00000014] block  leading-[46px] relative text-[#101130] text-[15px] font-bold font-roboto`}
                >
                  Portfolio
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className={` border-b border-[#00000014] block  leading-[46px] relative text-[#101130] text-[15px] font-bold font-roboto`}
                >
                  Blog
                </Link>
              </li>

              {/* <li onClick={() => setOpen(false)}>
                <Link
                  to="/shop"
                  className={` border-b border-[#00000014] block  leading-[46px] relative text-[#101130] text-[15px] font-bold font-roboto`}
                >
                  Shop
                </Link>
              </li> */}
            </ul>
          </div>
          <button
            onClick={() => setOpen(false)}
            className="bg-white border right-5 absolute top-5 border-[#0000002e] h-7  w-8"
          >
            <i className="fa-solid fa-xmark text-[14px] text-[#000]"></i>
          </button>
        </div>
      </div>
    </section>
  );
};

export default MobileMenu;
